import { useState } from "react";
import { useAppState } from "@/contexts/app-state";
import OrderTable from "@/components/OrderTable";
import Loader from "@/components/Loader";
import { useQueryKeys } from "@/hooks/use-query-keys";
import { useOrdersContext } from "@/contexts/orders-context";
import { useOrders } from "@/hooks/use-orders";

const MyTasksContainer = () => {
  const { loggedInUser } = useAppState();
  const [currentTable, setCurrentTable] = useState<string>("All");
  const { filters, sortOrder, sortCriteria } = useOrdersContext();
  const {
    isPending,
    data = { total: 0, rows: [], tabData: [], totalPages: 0, totalCount: 0 },
    isError,
    error,
    refetch,
    isRefetching,
    dataUpdatedAt,
  } = useOrders({
    user: loggedInUser,
    filters,
    sortCriteria,
    sortOrder,
  });
  const getQueryKey = useQueryKeys("orders");

  return (
    <div data-testid="tasks-wrapper">
      <Loader
        isLoading={isPending || isRefetching}
        displayText={
          isRefetching
            ? "Refreshing available cases..."
            : "Loading available cases..."
        }
        isError={isError}
        errorReason={error?.message}
      >
        <OrderTable
          totalItems={data?.totalCount}
          totalPages={data?.totalPages}
          tabs={data?.tabData}
          rows={data?.rows}
          ordersQueryKey={getQueryKey({ user: loggedInUser, filters })}
          table={{ currentTable, setCurrentTable }}
          refetch={() => void refetch()}
          dataUpdatedAt={dataUpdatedAt}
        />
      </Loader>
    </div>
  );
};

export default MyTasksContainer;
